<template>
  <div class="goback">
    <div class="backPosition" @click="goBackTop">
      <img src="../../../src/assets/images/newImgs/goback.png" />
      <span>{{ $t("l.header.goBack") }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "GoBack",
  data() {
    return {
      // msg: "Welcome to Your Vue.js App",
    };
  },
  methods: {
    goBackTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth' // 平滑滚动
      });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.goback{
  position:fixed;
  right:40px;
  bottom:100px;
  cursor: pointer;
  width: 70px;
  .backPosition{
    position:relative;
  }
  img{
    width: 100%;
  }
  span{
    position:absolute;
    bottom:10px;
    left:10px;
    color:rgba(140, 140, 140, 1);
    font-size: 13px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer/goBack.vue